// @flow

export const DatePickerStyles = `
  .dateRangeToggle {
    display: flex;
    align-items: center;
    font-size: 1rem;
    border-color: transparent;
    cursor: pointer;
  }
  
  .dateRangePicker {
    position: relative;  
    z-index: 2;
    
    i {
      margin-right: 1rem;
    }  
  }

`;

export const DoubleDatePickerStyles = `  
.doubleDatePicker {
  display: flex;
  justify-content: center;
}
.rdtPicker {
  border: 1px solid #a3a3a3;
  min-height: 230px;
  display: block;
  position: static;
  width: auto;
  padding: 0;
  margin-top: 0;
  box-shadow: none;
}
.rdtPicker table {
  width: 100%;
}
.rdtPicker thead {
  border-bottom: 1px solid #a3a3a3;
}
.rdtPicker thead th {
  background: #eee;
  padding: 6px;
  text-align: center;
  border-bottom: none;
}
.rdtPicker tbody td {
  padding: 6px;
  cursor: pointer;
  text-align: center;
  user-select: none;
}
.rdtPicker tbody td:hover {
  background: #eee;
  color: #000;
  font-weight: bold;
}
.rdtPicker tbody .rdtDisabled {
  cursor: not-allowed;
  color: #c3c3c3;
}
.rdtPicker tbody .rdtDisabled:hover {
  background: #fff;
  color: #c3c3c3;
}
.dow {
  font-size: 9px;
  color: #8e8e8e;
  padding: 3px;
}
.rdtDay {
  font-size: 11px;
  text-align: center;
}
.rdtNew,
.rdtOld {
  color: #c3c3c3;
}
td.rdtActive {
  background: #eee;
  color: #000;
  font-weight: bold;
}
.rdtSwitch {
  font-size: 11px;
}
.from {
  margin-right: 20px;
}
.dateRangeControls {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 10px;
}

.dateInput {
  width: 100%;
`;


// WEBPACK FOOTER //
// ./web_modules/trustar-2.0/components/DatePicker/DatePicker.styles.js